import { useReduxState } from 'hooks';
import { RichTextEditorInput } from 'components/common/richTextEditor';

import type { BlockHeading } from 'shared-types';

interface Props {
  data: BlockHeading;
  onChange: (text: string) => void;
  text: string;
}

const HeadingEditor = ({ data, onChange, text }: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="heading-editor">
      <RichTextEditorInput
        formatting={false}
        onChange={onChange}
        placeholder={messages.editorBlockHeadingPlaceholder}
        singleLine={true}
        singleLineRemoveParagraph={true}
        value={text}
        withBorder={false}
      />

      <style jsx>{`
        .heading-editor :global(.vuo-rich-text-editor) {
          font-size: ${data.headingLevel === 'H3' ? '1.8rem' : '2.2rem'};
          font-weight: bold;
          padding: 0;
        }
      `}</style>
    </div>
  );
};

export default HeadingEditor;
